import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import PlanTableFooter from './PlanTableFooter';
import PlanTableBody from './PlanTableBody';
import PlanTableHeader from './PlanTableHeader';
import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';

const PlanTableView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useBeneficiarySellModal();

  return (
    <div className="invoice-bills border rounded ">
      <div className="table-responsive scroll-horizontal">
        <table className="table table-striped mb-0 scroll-horizontal">
          <PlanTableHeader />

          <PlanTableBody />

          <PlanTableFooter />
        </table>

        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="custom-control custom-checkbox custom-control-sm ml-3">
            <input
              type="checkbox"
              className="custom-control-input"
              id="include-not-vested-units"
              checked={data.includeBeneficiaryNotVestedUnits}
              onChange={actions.handleChangeIncludeBeneficiaryNotVestedUnits}
            />
            <label
              className="custom-control-label fw-bold"
              htmlFor="include-not-vested-units"
            >
              {t('IncludeAllVestedUnits')}
            </label>
          </div>

          <span className="text-soft fs-11px mr-4">
            {t('AmountWithholdingTax')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PlanTableView;
